import React from 'react';

import PsychologicalTests from '../PsychologicalTests';

export interface PsychToolPageProps {
  onBack: () => void;
  onRequireLogin: () => void;
}

interface PsychToolPageBaseProps extends PsychToolPageProps {
  testId: string;
}

const PsychToolPageBase: React.FC<PsychToolPageBaseProps> = ({ onBack, onRequireLogin, testId }) => (
  <PsychologicalTests onBack={onBack} onRequireLogin={onRequireLogin} initialTestId={testId} />
);

export default PsychToolPageBase;
